import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import AuthModal from "../../../components/AuthModal";

export const Header = (props) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (currentUser) {
      navigate('/cheatsheet');
    } else {
      setShowAuthModal(true);
    }
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1 text-center" style={{ position: 'relative' }}>
              <h1>{props.data ? props.data.title : "Loading"}</h1>
              <p>{props.data ? props.data.paragraph : "Loading"}</p>
              <button onClick={handleGetStarted} className="btn-landing primary" style={{ position: 'relative', top: '-25px', zIndex: 10 }}>
                Get Started
              </button>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-10 col-md-offset-1">
              <img 
                src="/images/hero1.png"
                alt="AI Cheat Sheet Preview" 
                className="img-responsive"
                style={{
                  width: '100%',
                  maxWidth: '1000px',
                  margin: '0 auto',
                  borderRadius: '12px',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </header>
  );
};
